var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5C2.5 7.16848 2.6317 6.85054 2.86612 6.61612C3.10054 6.3817 3.41848 6.25 3.75 6.25H26.25C26.5815 6.25 26.8995 6.3817 27.1339 6.61612C27.3683 6.85054 27.5 7.16848 27.5 7.5C27.5 7.83152 27.3683 8.14946 27.1339 8.38388C26.8995 8.6183 26.5815 8.75 26.25 8.75H3.75C3.41848 8.75 3.10054 8.6183 2.86612 8.38388C2.6317 8.14946 2.5 7.83152 2.5 7.5ZM2.5 15.04C2.5 14.7085 2.6317 14.3905 2.86612 14.1561C3.10054 13.9217 3.41848 13.79 3.75 13.79H26.25C26.5815 13.79 26.8995 13.9217 27.1339 14.1561C27.3683 14.3905 27.5 14.7085 27.5 15.04C27.5 15.3715 27.3683 15.6895 27.1339 15.9239C26.8995 16.1583 26.5815 16.29 26.25 16.29H3.75C3.41848 16.29 3.10054 16.1583 2.86612 15.9239C2.6317 15.6895 2.5 15.3715 2.5 15.04ZM3.75 21.33C3.41848 21.33 3.10054 21.4617 2.86612 21.6961C2.6317 21.9305 2.5 22.2485 2.5 22.58C2.5 22.9115 2.6317 23.2295 2.86612 23.4639C3.10054 23.6983 3.41848 23.83 3.75 23.83H26.25C26.5815 23.83 26.8995 23.6983 27.1339 23.4639C27.3683 23.2295 27.5 22.9115 27.5 22.58C27.5 22.2485 27.3683 21.9305 27.1339 21.6961C26.8995 21.4617 26.5815 21.33 26.25 21.33H3.75Z",
    fill: "#A6A6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuIcon);
export default __webpack_public_path__ + "static/media/ic-menu-icon.f3b6f41462820b2d68944fa070ce16b0.svg";
export { ForwardRef as ReactComponent };